<div class="container-fluid section2-bg">
<div class="container">
  <h2>Create your own pizza</h2>
  <div class="row no-gutters">
    <div class="col-lg-6">
      <img
        class="img-fluid"
        src="/assets/img/pizza-gif.gif"
        alt="Pizza GIF"
        title="GIF"
        itemprop="thumbnailUrl"
      />
    </div>
    <div class="col-lg-1"></div>
    <div class="col-lg-5">
      <div class="mob-pl">
      <h3><i class="fas fa-tools"></i>Create your pizza</h3>
      
      <p>
        <i class="fas fa-long-arrow-alt-right"></i>Choose the size, crust,
        toppings, and more.
      </p>
      <h3><i class="fas fa-home"></i>Add your delivery address</h3>
      <p>
        <i class="fas fa-long-arrow-alt-right"></i>Add your address and place
        your order.
      </p>
      <h3><i class="fas fa-pizza-slice"></i>Enjoy your piece of sunshine!</h3>
      <p>
        <i class="fas fa-long-arrow-alt-right"></i>We're sure you'll love every
        bite.
      </p>
      <a type="button" class="btn btn-light btn-lg mb-2 pizza-btn" href="/createpizza">
        Create Your Pizza
      </a>
      </div>
    </div>
  </div>
</div>
</div>